import { tokens } from "styles/Tokens";

export const colorProps: any = {
  neutral: {
    borderStyle: `1px solid ${tokens.Border.General.Primary}`,
    textColor: `${tokens.Text.General.Secondary}`,
    bgColor: "unset"
  },
  colored: {
    borderStyle: `1px solid ${tokens.Border.General.Color}`,
    textColor: `${tokens.Text.General.Color}`,
    bgColor: `${tokens.Draggable.General.DraggedItem}`
  }
};
